import React from 'react';
import ReactDOM from 'react-dom';
import ActionSheet from './action-sheet';
import Confirm from './confirm';
import Info from './info';
import OriginModal from './modal';
import Prompt from './prompt';
export const Modal = OriginModal;
Modal.info = (props) => {
    const $info = document.createElement('div');
    function onUnMount() {
        ReactDOM.unmountComponentAtNode($info);
    }
    ReactDOM.render(React.createElement(Info, Object.assign({}, props, { onUnMount: onUnMount })), $info);
};
Modal.confirm = (props) => {
    const $confirm = document.createElement('div');
    function onUnMount() {
        ReactDOM.unmountComponentAtNode($confirm);
    }
    ReactDOM.render(React.createElement(Confirm, Object.assign({}, props, { onUnMount: onUnMount })), $confirm);
};
Modal.prompt = (props) => {
    const $prompt = document.createElement('div');
    function onUnMount() {
        ReactDOM.unmountComponentAtNode($prompt);
    }
    ReactDOM.render(React.createElement(Prompt, Object.assign({}, props, { onUnMount: onUnMount })), $prompt);
};
Modal.actionSheet = (props) => {
    const $actionSheet = document.createElement('div');
    function onUnMount() {
        ReactDOM.unmountComponentAtNode($actionSheet);
    }
    ReactDOM.render(React.createElement(ActionSheet, Object.assign({}, props, { onUnMount: onUnMount })), $actionSheet);
};
export default Modal;
